// Module
var code = "<!-- ko if: value -->\n  <foquz-icon class=\"f-icon-primary\" params=\"icon: 'filter'\"></foquz-icon>\n<!-- /ko -->\n";
// Exports
module.exports = code;